import styled from "styled-components";

const NoGamesDiv = styled.div`
  width: 90%;
  text-align: center;
`;

export default NoGamesDiv;
